import { GetServerSideProps } from 'next';
import { api, mimir } from '@/services/api';
import LastNewsRoot, { FeaturedNewsApi, FeaturedNewsType } from '@/pages/ultimas';
import getConcurrentPromises from '@/utils/getConcurrentPromises';
import { NavBarContentData, TimeLineApi } from '@/shared/types/home.types';

export default function PodcastPagination({ homeData, navBarData, tagsData, segmentacoes, timelineData }: FeaturedNewsType) {
  return (
    <LastNewsRoot
      homeData={homeData}
      timelineData={timelineData}
      navBarData={navBarData}
      tagsData={tagsData}
      manualTitle="Últimos Podcasts"
      manualRouting="podcast/ultimos"
      segmentacoes={segmentacoes}
      routeType="tipo"
      route="podcast"
    />
  );
}
export const getServerSideProps: GetServerSideProps = async context => {
  const { host } = context.req.headers;

  const mainReq = { promise: api.get<FeaturedNewsApi>(`/podcast/p1/`), link: `/podcast/ultimos/` };
  const timelineReq = { promise: mimir.get<TimeLineApi>(`/timelines/ultimas/tipo/podcast`), link: `/timelines/ultimas/tipo/podcast` };
  const responseMenuReq = { promise: api.get<NavBarContentData>(`/componentes/menu/`), link: `/componentes/menu/` };

  const { promiseData, data, statusCode } = await getConcurrentPromises({
    mainPromise: mainReq,
    navBarPromise: responseMenuReq,
    timelinePromise: timelineReq,
    host,
  });

  if (data.redirect || data.notFound) return data;

  const homeData = data.data;
  const navBarData: NavBarContentData = promiseData[responseMenuReq.link].data.data;
  const tagsData = data.ssr;
  const { segmentacoes } = data;
  const timelineData = promiseData[timelineReq.link].data.data;

  context.res.setHeader('Cache-Control', data.headers['Cache-control']);
  context.res.setHeader('Expires', data.headers.Expires);
  context.res.statusCode = statusCode;

  return {
    props: {
      tagsData,
      homeData,
      navBarData,
      segmentacoes,
      timelineData,
    },
  };
};
